import { call, put } from 'redux-saga/effects';
import { ApiError, ApiResponse } from 'store/api/types';
import { RefreshContactsRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { refreshContacts } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import {
  fetchViesContactsRequest,
  refreshContactsFailure,
  refreshContactsSuccess,
} from '../actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* refreshContactsSaga(action: RefreshContactsRequestAction) {
  try {
    let err: ApiError | null;
    const { connectionId } = action.payload;

    const response: ApiResponse = yield call(refreshContacts, connectionId);
    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(fetchViesContactsRequest(connectionId));
    yield put(refreshContactsSuccess());
    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.contacts-were-refreshed'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(refreshContactsFailure());
  }
}
